import { render } from "./DescriptionInline.vue?vue&type=template&id=1a458345&scoped=true"
import script from "./DescriptionInline.vue?vue&type=script&lang=js"
export * from "./DescriptionInline.vue?vue&type=script&lang=js"

import "./DescriptionInline.vue?vue&type=style&index=0&id=1a458345&scoped=true&lang=css"

import exportComponent from "E:\\gcm3\\AI Inventory\\codebasedevdemo\\demo-legacy-frontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1a458345"]])

export default __exports__